import { MergeAllIcon } from '@univerjs/icons';

// Plain-text placeholders; replace with SVG/icon components when ready.
const makeTextIcon = (label: string) => () => label;

export const LabelIcon = makeTextIcon('Label');
export const TextIcon = makeTextIcon('Text');
export const FormulaIcon = makeTextIcon('Formula');
export const NumberIcon = makeTextIcon('Number');
export const DateTimeIcon = makeTextIcon('DateTime');
export const LongLabelIcon = makeTextIcon('LongLabel');
export const LongTextIcon = makeTextIcon('LongText');
export const HeaderIcon = makeTextIcon('Header');
export const HeaderTextIcon = makeTextIcon('HeaderText');
export const ValueIcon = makeTextIcon('Value');
export const CompanyIcon = makeTextIcon('Company');
export const CountryIcon = makeTextIcon('Country');
export const CurrencyIcon = makeTextIcon('Currency');
export const CompanyDropdownIcon = makeTextIcon('CompanyDropdown');
export const InsertAccountCodeIcon = makeTextIcon('Account');
// Univer's own merge glyph, so the button looks unchanged.
export const MergeIcon = MergeAllIcon;
export const DeleteComponentIcon = makeTextIcon('Delete');
